import Button from "@mui/material/Button"
import ButtonGroup from "@mui/material/ButtonGroup"
import ClickAwayListener from "@mui/material/ClickAwayListener"
import Grow from "@mui/material/Grow"
import Paper from "@mui/material/Paper"
import Popper from "@mui/material/Popper"
import { FunctionComponent, ReactElement, useRef, useState } from "react"
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"
import { SxProps, Typography } from "@mui/material"

interface Props {
  title: string | ReactElement
  instruction: string | ReactElement
  sx?: SxProps
  properties: {
    disabled?: boolean
    onClick: () => void
    sx?: SxProps
  }
}

export const SplitButton: FunctionComponent<Props> = ({ title, sx, instruction, properties }) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLDivElement>(null)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }

    setOpen(false)
  }

  return (
    <>
      <ButtonGroup
        sx={{
          ml: 1,
          "& button": {
            background: "rgba(40,40,43, 0.9)",
            color: "white !important",
          },
          "& button:hover": {
            background: "rgba(40,40,43,1.0)",
          },
          "& button.Mui-disabled": {
            backgroundColor: "rgba(40,40,43, 0.6)",
            color: "white !important",
          },
          ...sx,
        }}
        ref={anchorRef}
        aria-label="Button group with a nested menu"
      >
        <Button
          onClick={properties.onClick}
          sx={{
            borderBottomLeftRadius: "3px !important",
            borderTopLeftRadius: "3px !important",
            ...properties.sx,
          }}
          disabled={properties.disabled}
        >
          {title}
        </Button>
        <Button
          sx={{
            // background: "#28282B",
            borderBottomRightRadius: "3px !important",
            borderTopRightRadius: "3px !important",
          }}
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          <HelpOutlineIcon />
        </Button>
      </ButtonGroup>
      <Popper
        sx={{ zIndex: 1 }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper sx={{ padding: "10px", color: "white", background: "#28282B" }}>
              <ClickAwayListener onClickAway={handleClose}>
                {typeof instruction === "string" ? (
                  <Typography>{instruction}</Typography>
                ) : (
                  instruction
                )}
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  )
}
